module.exports = __webpack_public_path__ + "img/bulgarians-DE.86ee5f5b.png";